import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { handleApiException } from '../../services/api.service'
import { TransitOperationPageAdminResponseReservationStatusEnum } from '../../api/models'

const baseUrl = process.env.REACT_APP_API_URL

function GuaranteeStatus() {
  const { search } = useLocation()
  const { t } = useTranslation('translation', { lng: 'en' })
  const { t: ruT } = useTranslation('translation', { lng: 'ru' })
  const [loading, setLoading] = useState<boolean>(true)
  const [reservationStatus, setReservationStatus] = useState<TransitOperationPageAdminResponseReservationStatusEnum>()
  const [mrnParam, setMrnParam] = useState<string>('')
  const [lrnParam, setLrnParam] = useState<string>('')

  const getGuaranteeStatus = (referenceNumber: string) => axios
    .get(`${baseUrl}/v2/transit-operation/guarantee-claim-status`, { params: { referenceNumber } })
    .catch(handleApiException)

  useEffect(() => {
    const queryParams = new URLSearchParams(search)
    const mrn = queryParams.get('mrn')
    const lrn = queryParams.get('lrn')

    if (mrn) {
      setMrnParam(mrn)
      getGuaranteeStatus(mrn)
        .then((value) => setReservationStatus(value.data))
        .finally(() => setLoading(false))
    } else if (lrn) {
      setLrnParam(lrn)
      getGuaranteeStatus(lrn)
        .then((value) => setReservationStatus(value.data))
        .finally(() => setLoading(false))
    } else {
      toast.error(t('common.error'))
      setLoading(false)
    }

    getGuaranteeStatus(mrnParam)
      .then((value) => setReservationStatus(value.data))
      .finally(() => setLoading(false))
  }, [search, mrnParam, t])

  return (
    <div className="guarantee-status__container">
      <div className="guarantee-status__card">
        <h1 className="d-flex justify-content-center w-100 rounded-top p-3 pb-1 text-uppercase">Tardek T1</h1>
        <h3 className="d-flex align-items-center flex-column mb-3 text-uppercase">
          <span>{mrnParam}</span>
          <span>{lrnParam}</span>
        </h3>
        <div className="d-flex flex-column mb-2">
          <div className="d-flex justify-content-center">
            {
              loading && (
                <i className="fa fa-spinner-third fa-spin me-2" />
              )
            }
            {
              !loading && (
                <p className="guarantee-status__explanation">
                  <span>
                    {t('messages.guaranteeStatus', { context: reservationStatus ?? '' })}
                  </span>
                  <span>
                    {ruT('messages.guaranteeStatus', { context: reservationStatus ?? '' })}
                  </span>
                </p>
              )
            }
          </div>

        </div>
      </div>
    </div>
  )
}

export default GuaranteeStatus
